import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import App from 'App';
import Theme from 'Theme';
import { TenantProvider } from 'tenants/TenantProvider';
import {
  getFallbackTenantConfig,
  loadActiveTenantConfig,
} from 'tenants/tenantConfigService';
import { TenantConfig } from 'tenants/types';

const AppBootstrap = () => {
  const [tenantConfig, setTenantConfig] = useState<TenantConfig | null>(null);

  useEffect(() => {
    let isMounted = true;

    const bootstrap = async () => {
      try {
        const { tenantConfig: resolvedTenantConfig } =
          await loadActiveTenantConfig();

        if (isMounted) {
          setTenantConfig(resolvedTenantConfig);
        }
      } catch (error) {
        if (isMounted) {
          setTenantConfig(getFallbackTenantConfig());
        }
      }
    };

    bootstrap();

    return () => {
      isMounted = false;
    };
  }, []);

  if (!tenantConfig) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <CircularProgress />
        <Typography variant="body2" color="text.secondary">
          Loading tenant configuration...
        </Typography>
      </Box>
    );
  }

  return (
    <TenantProvider config={tenantConfig}>
      <Theme tenantConfig={tenantConfig}>
        <App />
      </Theme>
    </TenantProvider>
  );
};

export default AppBootstrap;
